import { render, staticRenderFns } from "./edcContentNew.vue?vue&type=template&id=12f94c1a&"
import script from "./edcContentNew.vue?vue&type=script&lang=js&"
export * from "./edcContentNew.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports